import { render, staticRenderFns } from "./table-data-row.vue?vue&type=template&id=6343d1ff&scoped=true&"
import script from "./table-data-row.vue?vue&type=script&lang=js&"
export * from "./table-data-row.vue?vue&type=script&lang=js&"
import style0 from "./table-data-row.vue?vue&type=style&index=0&id=6343d1ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6343d1ff",
  null
  
)

export default component.exports